export const SQUARE_VERTICAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.SquareVerticalItemElement';
export const CIRCLE_VERTICAL_ITEM = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.CircleVerticalItemElement';
